import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";

const iconMap = {
  up: ArrowUp,
  down: ArrowDown,
  left: ArrowLeft,
  right: ArrowRight,
};

const sizeClasses = {
  lg: "w-16 h-16 md:w-24 md:h-24",
  sm: "w-7 h-7 md:w-9 md:h-9",
};

const ArrowDisplay = ({ sequence, progress = 0, size = "lg", testIdPrefix = "target" }) => {
  return (
    <div className="flex flex-wrap items-center gap-4" data-testid={`${testIdPrefix}-sequence`}>
      {sequence.map((direction, index) => {
        const Icon = iconMap[direction];
        const isActive = index < progress;
        return (
          <div
            key={`${direction}-${index}`}
            className={`flex items-center justify-center ${isActive ? "text-[#FFE800] glow-yellow" : "text-gray-700"}`}
            data-testid={`${testIdPrefix}-arrow-${direction}-${index}`}
          >
            <Icon className={`${sizeClasses[size]} stroke-[4px]`} />
          </div>
        );
      })}
    </div>
  );
};

export default ArrowDisplay;